export default {
  /**
   * Store identifier
   * @type {String}
   */
  id: 'common'
}
